import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";

import moment from "moment";
import numeral from "numeral";
import { Tooltip } from "antd";
import { isExpired } from "../../../libs/deadlinesUtils";

import {
  classByDeadline,
  getTypeByDeadline,
  deadlinesFilters,
  scrollToWithAnimation,
  deadlinesTypes
} from "../shared";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import RowListDeadlines from "../rowList";
import { FormattedMessage } from "react-intl";

const { Option } = Select;

class ListDeadlines extends Component {
  static propTypes = {
    navigate: PropTypes.any,
    filterList: PropTypes.object, 
    isSpinner: PropTypes.bool,
    listDeadlines: PropTypes.array,
    resetMonthView: PropTypes.func,
    selectedDay: PropTypes.object,
    setFilterList: PropTypes.func,
    toggleArchivedDeadline: PropTypes.func,
    prevPath: PropTypes.string,
    myType: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      filterListValues: null
    };
  }

  componentDidUpdate(prevProps) {
    let borderElementToAnimation = document.getElementsByClassName("bordered");
    if (borderElementToAnimation && borderElementToAnimation.length > 0) {
      // document.getElementById("scolledContainer").scrollTo(0, document.getElementsByClassName("bordered")[0].offsetTop - 300);
      scrollToWithAnimation(
        document.getElementById("scrolledContainer"),
        document.getElementsByClassName("bordered")[0].offsetTop - 300,
        1000,
        null
      );
    }
  }

  getTotalDaily() {
    const { listDeadlines } = this.props;
    const result = { toPay: 0, toCollect: 0 };
    if (!listDeadlines) {
      return result;
    }
    listDeadlines
      .filter(d => d.status && d.status.confirmed)
      .forEach(currentDeadline => {
        if (currentDeadline.totalAmount < 0) {
          result.toPay -= currentDeadline.totalAmount;
        } else {
          result.toCollect += currentDeadline.totalAmount;
        }
      });
    return result;
  }

  setFilterList(value) {
    const { setFilterList } = this.props;
    setFilterList(value);
  }

  /** Se si è sulla vista giornaliera torna alla vista mensile */
  renderBackToMonthView() {
    const {
      filterList: { monthView },
      resetMonthView
    } = this.props;

    return monthView ? null : (
      <div
        id="backToMonthView"
        style={{
          margin: "10px 20px",
          color: "#0090d1",
          cursor: "pointer",
          fontSize: "16px",
          letterSpacing: "0px",
          textAlign: "center"
        }}
        onClick={resetMonthView}
      >
        <Tooltip
          color={"rgb(0, 80, 117)"}
          placement="topLeft"
          title={<FormattedMessage id="deadlines.pages.calendar.monthView" />}
        >
          <FontAwesomeIcon icon={["fas", "arrow-left"]} />
        </Tooltip>
      </div>
    );
  }

  renderTitle() {
    const {
      filterList: { fromSelected, monthView }
    } = this.props;
    let currentDate = " ";
    if (monthView) {
      currentDate +=
        moment(fromSelected).format("MMMM") +
        " " +
        moment(fromSelected).format("YYYY");
    } else {
      currentDate += moment(fromSelected).format("DD MMMM YYYY");
    }
    return (
      <span className="CairoSemiBold24">
        <FormattedMessage id="deadlines.title" />
        {" " + currentDate}
      </span>
    );
  }

  renderEventList() {
    const { listDeadlines, filterList, toggleArchivedDeadline, navigate } = this.props;
    let listsArray = [];
    const today = moment().format(DATE_FORMAT_FOR_DISPLAY);
    const tomorrow = moment()
      .add(1, "days")
      .format(DATE_FORMAT_FOR_DISPLAY);
    const yesterday = moment()
      .add(-1, "days")
      .format(DATE_FORMAT_FOR_DISPLAY);

    for (let listCount = 0; listCount < listDeadlines.length; listCount++) {
      let currentListDeadline = listDeadlines[listCount];
      if (filterList.activeFilters && filterList.activeFilters.length > 0) {
      }
      // Forzare el.date con orario sempre T00:00:00.000Z in modo da evitare cambiamenti di giornate nella conversione orario UTC
      /*
      let datecursorToMoment = moment(
        currentListDeadline.date.split("T")[0] + "T00:00:00.000Z"
      ).format(DATE_FORMAT_FOR_API);
      */
      let letClassNameSelected = "bordered ";

      letClassNameSelected += classByDeadline(currentListDeadline);
      let title = <FormattedMessage id="generic.notAvailable" />;
      if (
        currentListDeadline.description &&
        currentListDeadline.description.title
      ) {
        if (currentListDeadline.description.title !== "-") {
          title =
            currentListDeadline.description.details &&
            (currentListDeadline.scope === "debt" ||
              currentListDeadline.scope === "credit")
              ? currentListDeadline.description.title +
                " " +
                currentListDeadline.description.details
              : currentListDeadline.description.title;
        } else if (
          currentListDeadline.description.title === "-" &&
          currentListDeadline.scope === "debt" &&
          currentListDeadline.counterpart &&
          currentListDeadline.counterpart.description
        ) {
          title = (
            <React.Fragment>
              <FormattedMessage id="deadlines.invoiceFrom" />
              {" " + currentListDeadline.counterpart.description}
            </React.Fragment>
          );
        } else if (
          currentListDeadline.description.title === "-" &&
          currentListDeadline.scope === "credit" &&
          currentListDeadline.counterpart &&
          currentListDeadline.counterpart.description
        ) {
          title = (
            <React.Fragment>
              <FormattedMessage id="deadlines.invoiceTo" />
              {" " + currentListDeadline.counterpart.description}
            </React.Fragment>
          );
        }
      }
      listsArray.push(<div
        key={listCount}
        className={`rowListDeadlinesContainer ${getTypeByDeadline(currentListDeadline) === deadlinesTypes.FiscalePianificate && "plannedDeadline"}`}
      >
        {getTypeByDeadline(currentListDeadline) ===
              deadlinesTypes.FiscalePianificate && (
          <div className="falseBorderPlannedDeadlines"></div>
        )}
        <div
          key={"rowList_" + currentListDeadline.id}
          className={letClassNameSelected}
          id={"rowList_" + currentListDeadline.id}
        >
          <RowListDeadlines
            navigate={navigate}
            // Forzare el.date con orario sempre T00:00:00.000Z in modo da evitare cambiamenti di giornate nella conversione orario UTC
            data={currentListDeadline.date.split("T")[0] + "T00:00:00.000Z"}
            description={
              currentListDeadline.description
                ? currentListDeadline.description.details
                : ""
            }            
            id={currentListDeadline.id}
            isArchived={currentListDeadline?.status?.archived}
            isHideBtn={isExpired(listDeadlines[listCount])}
            status={currentListDeadline.status}
            title={title}
            toggleArchivedDeadline={toggleArchivedDeadline.bind(this,
              currentListDeadline)}
            total={currentListDeadline.totalAmount}
            paymentStatus={currentListDeadline?.payment?.status}
            compensation={
              currentListDeadline?.payment?.compensation
                ? currentListDeadline?.payment?.compensation
                : ""
            }
            scope={currentListDeadline?.scope}
            today={today}
            tomorrow={tomorrow}
            yesterday={yesterday}
          />
        </div>
      </div>);
    }
    return listsArray;
  }

  renderFilterListType() {
    const {
      filterList: { activeFilters }
    } = this.props;
    const activeF =
      activeFilters && activeFilters.length === 1
        ? activeFilters[0].split(",")
        : activeFilters;
    let optionsList = [];
    for (let op = 0; op < deadlinesFilters.length; op++) {
      optionsList.push(<Option
        value={deadlinesFilters[op].value}
        key={op}
      >
        <Tooltip placement="leftTop" 
          color={"rgb(0, 80, 117)"}
          title={deadlinesFilters[op].label}>
          {deadlinesFilters[op].label}
        </Tooltip>
      </Option>);
    }
    return (
      <Select
        mode="multiple"
        maxTagCount={1}
        placeholder="Tutte"
        style={{ height: "40px", width: "299px" }}
        value={activeF}
        onChange={el => {
          this.setFilterList(el);
        }}
      >
        {optionsList}
      </Select>
    );
  }

  renderTotalAmount(totalDaily) {
    if (!totalDaily || (totalDaily.toPay === 0 && totalDaily.toCollect === 0)) {
      return null;
    }

    function renderSingleImport(
      id,
      label,
      amountString,
      hasSibling,
      amountFontSize,
      iconTitle,
      iconColor
    ) {
      if (!amountString) return null;
      const marginRigthSize = hasSibling ? "30px" : undefined;
      return (
        <div id={id} style={{ marginRight: marginRigthSize, minWidth: "35%" }}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <FontAwesomeIcon
              style={{ color: iconColor }}
              icon={["fas", iconTitle]}
            />
            <div className="totalLabel">{label}</div>
          </div>
          <div className="totalAmount" style={{ fontSize: amountFontSize }}>
            {amountString}
          </div>
        </div>
      );
    }

    function amountToString(amount) {
      return amount === 0 ? "" : numeral(amount).format("0,0.00") + " €";
    }

    let toPay = amountToString(totalDaily.toPay);
    let toCollect = amountToString(totalDaily.toCollect);
    const amountFontSize =
      Math.max(toPay.length, toCollect.length) <= "9.999,00 €".length
        ? "17px"
        : "13px";

    return (
      <div>
        <div
          id="allTotalAmounts"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "40px"
          }}
        >
          {renderSingleImport(
            "totalAmounts_toCollect",
            <FormattedMessage id="deadlines.collect" />,
            toCollect,
            false,
            amountFontSize,
            "plus-circle",
            "#0d6c80"
          )}
          {renderSingleImport(
            "totalAmounts_toPay",
            <FormattedMessage id="deadlines.pay" />,
            toPay,
            totalDaily.toCollect !== 0,
            amountFontSize,
            "minus-circle",
            "#c53090"
          )}
        </div>
      </div>
    );
  }

  render() {
    const { isSpinner, listDeadlines } = this.props;
    let totalDaily = this.getTotalDaily();

    return (
      <div className="listCalendarDeadlines">
        <div style={{ display: "flex", flexDirection: "row", height: "60px" }}>
          {this.renderBackToMonthView()}
          {this.renderTitle()}
        </div>
        <div className="flexContainer">
          <div className="description">
            <FormattedMessage id="actions.display" />
          </div>
          {this.renderFilterListType()}
        </div>
        <div className="flexCol">{this.renderTotalAmount(totalDaily)}</div>
        <div id="scrolledContainer">
          {listDeadlines && listDeadlines.length > 0 ? (
            this.renderEventList()
          ) : isSpinner ? (
            "spinner"
          ) : (
            <div style={{ textAlign: "center" }}>
              <FormattedMessage id="deadlines.pages.calendar.noDataWithFilters" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ListDeadlines;
